'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Graph;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _group = require('@vx/group');

var _Links = require('./Links');

var _Links2 = _interopRequireDefault(_Links);

var _Nodes = require('./Nodes');

var _Nodes2 = _interopRequireDefault(_Nodes);

var _DefaultLink = require('./DefaultLink');

var _DefaultLink2 = _interopRequireDefault(_DefaultLink);

var _DefaultNode = require('./DefaultNode');

var _DefaultNode2 = _interopRequireDefault(_DefaultNode);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Graph(_ref) {
  var graph = _ref.graph,
      _ref$linkComponent = _ref.linkComponent,
      linkComponent = _ref$linkComponent === undefined ? _DefaultLink2.default : _ref$linkComponent,
      _ref$nodeComponent = _ref.nodeComponent,
      nodeComponent = _ref$nodeComponent === undefined ? _DefaultNode2.default : _ref$nodeComponent;
  return _react2.default.createElement(_group.Group, null, _react2.default.createElement(_Links2.default, {
    links: graph.links,
    linkComponent: linkComponent
  }), _react2.default.createElement(_Nodes2.default, {
    nodes: graph.nodes,
    nodeComponent: nodeComponent
  }));
}